/**
 *
 * Asynchronously loads the component for Agenda
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Agenda/Loadable.js